module.exports = __webpack_public_path__ + "img/126.321ad8e1.jpg";